import Collectivity from 'src/models/collectivity.js';

export function setCollectivity(state, payload) {
  state.collectivity = new Collectivity(payload);
}

export function clearCollectivity(state) {
  state.collectivity = undefined;
}
